import BuildingBlockLayout from './building_block_layout.jsx'

const BuildingBlockPage = () => {
  return (
      <BuildingBlockLayout />
  );
};

export default BuildingBlockPage;